import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SubscriptionPackagesService } from 'src/app/pages/setup/subscription-settings/subscription-packages/subscription-packages.service';
import { SnackService } from '../../shared/components/snack/snack.service';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon'
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-subscription-quote-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    TranslateModule,
    MatIconModule,
    CommonModule
  ],
  template: `
   <div [dir]="_translate.currentLang == 'ar' ? 'rtl' : 'ltr'" class="quote-dialog-container">
   <h2 mat-dialog-title>
  {{ data.packageName ? (_translate.instant('SUBSCRIPTION_SETTINGS.Request_Quote_For') + ' ' + data.packageName) : ('SUBSCRIPTION_SETTINGS.Request_Custom_Package_Quote' | translate) }}
</h2>

  <mat-dialog-content>
    <form [formGroup]="quoteForm">
      <div class="form-field">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{'QUOTATION_FORM.LABEL_USERS' | translate}}</mat-label>
          <input matInput type="number" formControlName="numberOfUsers" min="1">
          <mat-error *ngIf="quoteForm.get('numberOfUsers').hasError('required')">
          {{'SUBSCRIPTION_SETTINGS.Number_of_users_is_required' | translate}}
          </mat-error>
          <mat-error *ngIf="quoteForm.get('numberOfUsers').hasError('min')">
          {{'SUBSCRIPTION_SETTINGS.Number_of_users_must' | translate}}
          </mat-error>
        </mat-form-field>
      </div>
      
      <div class="form-field">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{'SUBSCRIPTION_SETTINGS.Package_Details' | translate}}</mat-label>
          <textarea matInput formControlName="packageDetails" rows="4" 
                    placeholder="{{'QUOTATION_FORM.DETAILS_PLACEHOLDER' | translate}}"></textarea>
          <mat-error *ngIf="quoteForm.get('packageDetails').hasError('required')">
          {{'SUBSCRIPTION_SETTINGS.Package_details_are_required' | translate}}
          </mat-error>
        </mat-form-field>
      </div>
    </form>
    </mat-dialog-content>
  
  <mat-dialog-actions align="end" class="dialog-actions">
  <button mat-button class="cancel-button" (click)="onCancel()">
    {{ 'QUOTATION_FORM.CANCEL_BUTTON' | translate }}
  </button>

  <button mat-raised-button color="primary" class="submit-button"
          (click)="onSubmit()" [disabled]="quoteForm.invalid || isLoading">
    <div class="button-content">
      <span *ngIf="isLoading" class="spinner-button">
        <mat-spinner diameter="20"></mat-spinner>
      </span>
      <span>{{submitButtonText}}</span>
    </div>
  </button>
</mat-dialog-actions>
</div>
  `,
  styles: [`
.dialog-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  padding: 1rem 0;
}


.cancel-button {
  font-size: 14px;
  color:rgb(0, 0, 0);
  background: transparent;
  border: none;
  cursor: pointer;
}


.submit-button {
  background-color: #6a1b9a !important; 
  color: white !important;
  border-radius: 50px; 
  padding: 5px 12px;
  font-size: 14px;
  font-weight: 500;
  text-transform: none; 
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px; 
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);
}


.button-content {
  display: flex;
  align-items: center;
  gap: 8px;
}


.submit-button mat-icon {
  font-size: 18px;
}


.submit-button:disabled {
  background-color: #E0E0E0 !important; 
  color: #9E9E9E !important; 
  cursor: not-allowed;
  box-shadow: none;
}


.send-icon {
  margin-right: 0.5rem;
}


.send-icon {
  margin-right: 8px;
}

  .quote-dialog-container {
  min-width: 400px;
  max-width: 600px;
}

.full-width {
  width: 100%;
}

.form-field {
  margin-bottom: 16px;
}

.spinner-button {
  display: inline-block;
  margin-right: 8px;
}

mat-dialog-actions {
  padding: 16px 0;
}

/* Package type labels */
.package-type-label {
  margin-top: -10px;
  margin-bottom: 16px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  padding: 5px 0;
  border-radius: 4px;
  font-weight: 500;
  text-align: center;
}

.quotation-required {
  color: #f44336;
  font-weight: 500;
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  background-color: rgba(244, 67, 54, 0.1);
}

.can-customize {
  color: #2196f3;
  font-weight: 500;
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  background-color: rgba(33, 150, 243, 0.1);
}

.standard {
  color: #4caf50;
  font-weight: 500;
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  background-color: rgba(76, 175, 80, 0.1);
}
  `]
})
export class SubscriptionQuoteDialogComponent implements OnInit {
  quoteForm: FormGroup;
  isLoading = false;
  submitButtonText: string = '';

  constructor(
    public _translate: TranslateService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<SubscriptionQuoteDialogComponent>,
    private subscriptionPackageService: SubscriptionPackagesService,
    private snack: SnackService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.submitButtonText = this._translate.instant('QUOTATION_FORM.SUBMIT_BUTTON');
  }

  ngOnInit(): void {
    // Initialize the form
    this.quoteForm = this.fb.group({
      numberOfUsers: [1, [Validators.required, Validators.min(1)]],
      packageDetails: ['', Validators.required]
    });

    console.log('SubscriptionQuoteDialog initialized with data:', this.data);
  }

  onSubmit(): void {
    if (this.quoteForm.invalid) {
      return;
    }

    this.isLoading = true;
    const quoteData = {
      packageName: this.data.packageName || '',
      numberOfUsers: this.quoteForm.get('numberOfUsers').value,
      packageDetails: this.quoteForm.get('packageDetails').value,
      isCustomPackage: !!this.data.isCustomPackage,
      isRequiredQuotation: !!this.data.isRequiredQuotation
    };

    // Call service to submit quote request
    this.subscriptionPackageService.submitQuoteRequest(quoteData).subscribe(
      (response) => {
        this.isLoading = false;
        if (response.success) {
          this.snack.showSnack('QUOTATION_FORM.SUCCESS_MESSAGE', 'success');
          this.dialogRef.close(true);
        } else {
          this.snack.showSnack('QUOTATION_FORM.ERROR_MESSAGE', 'error');
        }
      },
      (error) => {
        this.isLoading = false;
        console.error('Error submitting quote request:', error);
        this.snack.showSnack('QUOTATION_FORM.ERROR_MESSAGE', 'error');
      }
    );
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}